var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "online_service_config",
      attrs: {
        model: _vm.value.config,
        disabled: _vm.disabled,
        rules: _vm.rules,
      },
    },
    [
      _c(
        "el-form-item",
        { attrs: { prop: "after_click_function" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v("组件点击后的功能")]),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.config.after_click_function,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "after_click_function", $$v)
                },
                expression: "value.config.after_click_function",
              },
            },
            [
              _c(
                "div",
                { staticClass: "radio-box" },
                [
                  _c("el-radio", { attrs: { label: "1" } }, [
                    _vm._v("拨打客服电话"),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "radio-box" },
                [
                  _c("el-radio", { attrs: { label: "2" } }, [
                    _vm._v("弹窗展示在线客服二维码"),
                  ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm.value.config.after_click_function === "1"
        ? [
            _c(
              "el-form-item",
              { attrs: { prop: "service_hotline_source" } },
              [
                _c("div", { staticClass: "label" }, [_vm._v("客服电话")]),
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.value.config.service_hotline_source,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.value.config,
                          "service_hotline_source",
                          $$v
                        )
                      },
                      expression: "value.config.service_hotline_source",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "radio-box" },
                      [
                        _c("el-radio", { attrs: { label: "1" } }, [
                          _vm._v(
                            " 取渠道基本信息客服电话 " +
                              _vm._s(
                                _vm.channel_service_hotline
                                  ? "(" + _vm.channel_service_hotline + ")"
                                  : ""
                              ) +
                              " "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "radio-box" },
                      [
                        _c("el-radio", { attrs: { label: "2" } }, [
                          _vm._v("单独填写"),
                        ]),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm.value.config.service_hotline_source === "2"
              ? _c(
                  "el-form-item",
                  {
                    key: "service_hotline",
                    attrs: { prop: "service_hotline" },
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入客服电话", clearable: "" },
                      model: {
                        value: _vm.value.config.service_hotline,
                        callback: function ($$v) {
                          _vm.$set(_vm.value.config, "service_hotline", $$v)
                        },
                        expression: "value.config.service_hotline",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm.value.config.after_click_function === "2"
        ? [
            _c(
              "el-form-item",
              { attrs: { prop: "qr_code_source" } },
              [
                _c("div", { staticClass: "label" }, [_vm._v("在线客服二维码")]),
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.value.config.qr_code_source,
                      callback: function ($$v) {
                        _vm.$set(_vm.value.config, "qr_code_source", $$v)
                      },
                      expression: "value.config.qr_code_source",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "radio-box" },
                      [
                        _c("el-radio", { attrs: { label: "1" } }, [
                          _vm._v("取渠道基本信息客服二维码"),
                        ]),
                      ],
                      1
                    ),
                    _c("el-image", {
                      staticClass: "code_img",
                      attrs: {
                        src: _vm.channel_qr_code,
                        fit: "contain",
                        "preview-src-list": [_vm.channel_qr_code],
                      },
                    }),
                    _c(
                      "div",
                      { staticClass: "radio-box" },
                      [
                        _c("el-radio", { attrs: { label: "2" } }, [
                          _vm._v("单独上传"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.value.config.qr_code_source === "2"
              ? _c(
                  "el-form-item",
                  { key: "qr_code", attrs: { prop: "qr_code" } },
                  [
                    _c("div", { staticClass: "box" }, [
                      _c("div", { staticClass: "upload-item-wrap" }, [
                        _c(
                          "div",
                          { staticClass: "left" },
                          [
                            _c("upload-file", {
                              ref: "uploadBanner",
                              attrs: {
                                "link-url": _vm.linkUrl,
                                tempurl: _vm.value.config.qr_code,
                                uploadInfo: _vm.uploadInfo,
                              },
                              on: { emitUploadFile: _vm.emitUploadFile },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "right" },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { margin: "0" },
                                on: { click: _vm.deleteImg },
                              },
                              [_vm._v("删除图片")]
                            ),
                            _c(
                              "el-button",
                              {
                                staticStyle: { margin: "0" },
                                attrs: { type: "primary" },
                                on: { click: _vm.upload },
                              },
                              [_vm._v("上传图片")]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }